import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MIN_ZOOM, MAX_ZOOM, getZoomIn, getZoomOut } from '@/util/zoom.js';
import actions from '@/action/panZoom.js';
import toolActions from '@/action/tools.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import Tooltip from '@material-ui/core/Tooltip';

import { faToggleOn as ToggleOnIcon } from '@fortawesome/pro-regular-svg-icons';
import { faToggleOff as ToggleOffIcon } from '@fortawesome/pro-regular-svg-icons';



// import { withStyles } from '@material-ui/core/styles';
import styles from './Toolbar.module.css';


console.log('toolActions', toolActions);
console.log('actions', actions);
// redo-alt
// undo-alt
// play
// 

// console.log('star', falExpand, farExpand, fasExpand);
// library.add(falExpand, farExpand, fasExpand);

/** Test component description */
class Toolbar extends Component {
    constructor(props) {
        super(props);

        this.config = props.config;

        this.toggleMultiselect = this.toggleMultiselect.bind(this);
        this.setToolNotecard = this.setToolNotecard.bind(this);
        // this.zoomTo = this.zoomTo.bind(this);

        const noop = ()=>{};
        // this.tweenZoom = this.props.tweenZoom ? this.props.tweenZoom.bind(this) : this.basicZoom.bind(this);
        // this.cancelTweenZoom = this.props.cancelTweenZoom ? this.props.cancelTweenZoom.bind(this) : noop;
        // this.tweenZoomUpdate = this.props.tweenZoomUpdate ? this.props.tweenZoomUpdate.bind(this) : noop;        
    }

    // basicZoom(targetZ) {
    //     this.props.setZoom(targetZ);
    // }

    setToolNotecard() {
        this.props.setCurrentTool('NOTECARD');
    }

    toggleMultiselect() {
        // this.setState({
        //     multiselect: !this.state.multiselect
        // })

        this.props.setMultiselectDefault(!this.props.multiselect);

    }

    render() {

        const actions = {
            onClick: function(e) {
                console.log('click');
            },
            onTouchStart: function(e) {
                console.log('touch');
            },
            onTouchEnd: function(e) {
                console.log('touch end');
            },
            onMouseOver: function(e) {
                // console.log('over');
            },
            onMouseOut: function(e) {
                // console.log('out');
            }
        }

        // <Button aria-label="Delete" variant="outlined" action={wtf}>
        // <FontAwesomeIcon icon={["fas", "minus-circle"]} />
        // <FontAwesomeIcon icon={["fas", "plus-circle"]} />
        // </Button>

        return (<div className={`ui ${styles.toolbar}`}>
            


            <span className={styles.textLabel}>Tool:</span>

            <Tooltip title="~ Notecard" classes={{ tooltip: 'tooltip' }} enterDelay={800}>
                <Button
                    aria-label="~ Notecard"
                    className="clickable"
                    classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                    disableFocusRipple
                    variant="outlined"
                    // action={wtf}
                    
                    onClick={
                        ()=>{this.setToolNotecard()}
                    }
                    onMouseOver={actions.onMouseOver}
                    onMouseOut={actions.onMouseOut}

                    disabled={this.props.currentTool == 'NOTECARD'}
                >
                    <div className={styles.textLabel}>Notecard</div>
                </Button>
            </Tooltip>

            <span className={styles.separator}>|</span>
        

            <Tooltip title="Select" classes={{ tooltip: 'tooltip' }} enterDelay={800}> 
                <span>
                    <Button
                        aria-label="Select"
                        classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                        className="clickable"
                        variant="outlined"
                        disableFocusRipple
                        // action={wtf}
                        onClick={() => {
                            this.props.setCurrentTool('SELECT');
                        }}

                        onMouseOver={actions.onMouseOver}
                        onMouseOut={actions.onMouseOut}

                        disabled={this.props.currentTool == 'SELECT'}
                    >
<div className={styles.textLabel}>Select</div>
                    </Button>
                </span>
            </Tooltip>


            {/* <Tooltip title="Marquee" classes={{ tooltip: 'tooltip' }} enterDelay={800}> 
                <span>
                    <Button
                        aria-label="Marquee"
                        classes={{ root: 'button', focusVisible: 'button-focus' }}
                        className="clickable"
                        variant="outlined"
                        disableFocusRipple
                        // action={wtf}
                        onClick={() => {
                            this.props.setCurrentTool('MARQUEE');
                        }}

                        onMouseOver={actions.onMouseOver}
                        onMouseOut={actions.onMouseOut}

                        disabled={this.props.currentTool == 'MARQUEE'}
                    >
<div className={styles.textLabel}>Marquee</div>
                    </Button>
                </span>
            </Tooltip> */}


            <Tooltip title="Pan" classes={{ tooltip: 'tooltip' }} enterDelay={800}> 
                <span>
                    <Button
                        aria-label="Pan"
                        classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                        className="clickable"
                        variant="outlined"
                        disableFocusRipple
                        // action={wtf}
                        onClick={() => {
                            this.props.setCurrentTool('PAN');
                        }}

                        onMouseOver={actions.onMouseOver}
                        onMouseOut={actions.onMouseOut}

                        disabled={this.props.currentTool == 'PAN'}
                    >
<div className={styles.textLabel}>Pan</div>
                    </Button>
                </span>
            </Tooltip>

            <span className={styles.separator}>|</span>

            <span className={styles.textLabel}>Selection:</span>
            
            <Tooltip title="Single Select" classes={{ tooltip: 'tooltip' }} enterDelay={800}>
                <span>
                    <Button
                        aria-label="Single Select"
                        className="clickable"
                        classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                        disableFocusRipple
                        variant="outlined"
                        // action={wtf}
                        
                        onClick={() => {
                            this.props.setMultiselectDefault(false);
                        }}

                        // onMouseOver={actions.onMouseOver}
                        // onMouseOut={actions.onMouseOut}
                        disabled={this.props.multiselect == false}
                    >
                        <div className={styles.textLabel}>Single</div>
                    </Button>
                </span>
            </Tooltip>



            <Tooltip title="~ Select" classes={{ tooltip: 'tooltip' }} enterDelay={800}>
                <Button
                    aria-label="~ Select"
                    className="clickable"
                    classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                    disableFocusRipple
                    variant="outlined"
                    // action={wtf}
                    
                    onClick={this.toggleMultiselect}
                >
                    { this.props.multiselect ? 
                        <FontAwesomeIcon
                            icon={ ToggleOnIcon }
                        />

                    : 
                        <FontAwesomeIcon
                            icon={ ToggleOffIcon }
                        />
                    }
                </Button>
            </Tooltip>

            <Tooltip title="Multiple Select" classes={{ tooltip: 'tooltip' }} enterDelay={800}>
                <span>
                    <Button
                        aria-label="Multiple Select"
                        className="clickable"
                        classes={{ root: styles.button, focusVisible: styles.buttonFocus }}
                        disableFocusRipple
                        variant="outlined"
                        // action={wtf}
                        
                        onClick={() => {
                            this.props.setMultiselectDefault(true);
                        }}

                        // onMouseOver={actions.onMouseOver}
                        // onMouseOut={actions.onMouseOut}
                        disabled={this.props.multiselect == true}
                    >
                        <div className={styles.textLabel}>Multi</div>
                    </Button>
                </span>
            </Tooltip>

            {this.props.children}
        </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return Object.assign({}, { 
        z: state.camera.zoom,
        // width: state.camera.size.width,
        // height: state.camera.size.height,
        // panX: state.camera.pan.x,
        // panY: state.camera.pan.y,
        multiselect: state.tool.multiselect,
        currentTool: state.tool.current
    }, ownProps);
}

Toolbar.displayName = "ToolbarComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions,
        ...toolActions
    }
)(Toolbar);
connectedComponent.displayName = "Toolbar";

/**
 * Huzzah!
 */
Toolbar.propTypes = {

};

export default connectedComponent;
export { Toolbar as ToolbarComponent };